module.exports = __webpack_public_path__ + "bf2532df/img/logo_sourcery.b41c4452.svg";